// ----------------------------------------------------------------------------
// KpiCards
// ----------------------------------------------------------------------------
// Top-row dashboard highlight cards. Pure presentational — values are passed in
// or derived from the parent's data. Replace the numeric props with values
// computed from a live API response.
// ----------------------------------------------------------------------------

import React from "react";
import { Briefcase, Wallet, CalendarClock, ArrowUpRight } from "lucide-react";
import { KPI } from "../constants/testIds";

const Card = ({ testId, label, value, sub, icon: Icon, accent }) => (
  <div
    data-testid={testId}
    className="bg-white border border-slate-200 rounded-lg p-6 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200"
  >
    <div className="flex items-start justify-between">
      <div className="space-y-1.5">
        <p className="text-[11px] uppercase tracking-[0.15em] text-slate-500 font-semibold">
          {label}
        </p>
        <p className="font-display text-3xl font-semibold text-slate-900 tracking-tight">
          {value}
        </p>
        {sub && (
          <p className="text-xs text-slate-500 flex items-center gap-1 pt-1">
            <ArrowUpRight size={13} strokeWidth={1.8} className="text-emerald-600" />
            {sub}
          </p>
        )}
      </div>
      <div
        className={`h-10 w-10 rounded-md flex items-center justify-center border ${accent}`}
      >
        <Icon size={18} strokeWidth={1.6} />
      </div>
    </div>
  </div>
);

export const KpiCards = ({ totalActive, contractValue, closingThisWeek }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <Card
        testId={KPI.card("active")}
        label="Total Active Bids"
        value={totalActive}
        sub="Across 3 agencies"
        icon={Briefcase}
        accent="bg-sky-50 border-sky-100 text-sky-600"
      />
      <Card
        testId={KPI.card("value")}
        label="Brevard Contract Value"
        value={contractValue}
        sub="Aggregate pipeline"
        icon={Wallet}
        accent="bg-emerald-50 border-emerald-100 text-emerald-600"
      />
      <Card
        testId={KPI.card("closing")}
        label="Closing This Week"
        value={closingThisWeek}
        sub="Action required"
        icon={CalendarClock}
        accent="bg-amber-50 border-amber-100 text-amber-600"
      />
    </div>
  );
};
